import { FormItemContainer, FormItemProps } from "./FormItemContainer";

type Props = {
  value?: string;
  onChange: (value: string) => void;
  dataCy?: string;
};
export const FormIsoDatePicker = (props: Props & FormItemProps<string>) => {
  //

  return (
    <FormItemContainer<string> {...props} additionalClassNames={`form-iso-date-picker ${props.additionalClassNames}`}>
      <input
        type="date"
        value={props.value ?? ""}
        onChange={(event) => {
          props.onChange(event.target.value);
        }}
      ></input>
    </FormItemContainer>
  );
};
